import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ServiceWorkerService, SplashService } from '@context/frontend/common';
import { getOS, getUaDevice } from '@context/frontend/native/platform';
import { TuiLoader, TuiRoot } from '@taiga-ui/core';

@Component({
	imports: [TuiRoot, RouterModule, TuiLoader, AsyncPipe],
	selector: 'ctx-root',
	templateUrl: 'app.component.html',
	styleUrl: 'app.component.scss',
	host: {
		'[attr.device]': 'device',
		'[attr.os]': 'os',
	},
})
export class AppComponent {
	public readonly splash = inject(SplashService);
	private readonly swService = inject(ServiceWorkerService);

	readonly device = getUaDevice();
	readonly os = getOS();

	ngOnInit() {
		this.swService.checkForUpdate$.subscribe();
	}
}
